import { u as s, E as a, y as c } from "./eMyAsurionProvider-5bc36307.js";
import { B as K } from "./eMyAsurionProvider-5bc36307.js";
import { j as u } from "./jsx-runtime-944c88e2.js";
import { Image as f } from "@chakra-ui/react";
import "react";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import { processContentfulImageToWebp as l } from "./myasurion-shared.utils.es.js";
import "./features-979fdcf7.js";
import "@tanstack/react-query";
import "@chakra-ui/icons";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "./lodash-9598aa3c.js";
import "./cleave-react-node-c4a374e5.js";
import "@emotion/react";
import "@emotion/styled";
import "framer-motion";
import "@react-oauth/google";
import "./myasurion-shared.widgets.es.js";
import "mixpanel-browser";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "./myasurion-shared.colors.es.js";
const G = ({ onClick: m, styleProps: p }) => {
  const { data: e } = s(), { theme: i } = e, {
    components: { chat: o }
  } = i, { chatConfig: t, firebaseConfig: n } = a(), { imageUrl: r } = c(
    o.agentIconSlug,
    t == null ? void 0 : t.contentful.space,
    t == null ? void 0 : t.contentful.token,
    t == null ? void 0 : t.contentful.env,
    n
  );
  return /* @__PURE__ */ u.jsx(
    f,
    {
      className: "onboarding__chat",
      src: r ? l(r) : o.chatIcon,
      cursor: "pointer",
      onClick: m,
      boxSize: "60px",
      alt: "Chat button image",
      ...p
    }
  );
};
export {
  K as Chat,
  G as ChatButton,
  a as useChatConfig
};
